import { Component } from '@angular/core';
import { AppState } from '../../../../../app/app.global';
import { NavParams } from 'ionic-angular';

@Component({
  selector: 'problemdetail-page',
  templateUrl: 'problemdetail.html'
})

export class ProblemDetail{
  question:any;
	constructor(public global: AppState,public params: NavParams) {
		this.question = params.data;
	}
}


// WEBPACK FOOTER //
// ./src/pages/application/dailyoffice/helpcenter/problemdetail/problemdetail.ts